<template>
  <div class="tnum">
    {{ fraction }}
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import swiper from '../utils/swiper';

export default defineComponent({
  setup() {
    const fraction = computed(() => {
      if (swiper.value) {
        return `${swiper.value.activeIndex + 1}/${swiper.value.slides.length}`;
      }
      return null;
    });

    return { fraction };
  },
});
</script>
